function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
var CheckboxesByCategory = /*#__PURE__*/function () {
  function CheckboxesByCategory(categoriesData, selectedFields) {
    _classCallCheck(this, CheckboxesByCategory);

    this.categoriesData = categoriesData;
    this.selectedFields = selectedFields;
  }

  _createClass(CheckboxesByCategory, [{
    key: "findCategoryById",
    value: function findCategoryById(id) {
      return this.categoriesData.filter(function (categoryData) {
        return categoryData['id'] === id;
      })[0];
    }
  }, {
    key: "findCategoryByContainingValueFor",
    value: function findCategoryByContainingValueFor(attribute, attrValue) {
      return this.categoriesData.filter(function (categoryData) {
        return categoryData[attribute] && categoryData[attribute].includes(attrValue);
      })[0];
    }
  }, {
    key: "isCategoryFullyCompleted",
    value: function isCategoryFullyCompleted(updatedField, fieldsForCategory) {
      var _this = this;

      var selectedFields = Object.keys(this.selectedFields).filter(function (fieldName) {
        return _this.selectedFields[fieldName];
      });
      selectedFields = [].concat(_toConsumableArray(selectedFields), [updatedField]);

      if (fieldsForCategory.every(function (_field) {
        return selectedFields.includes(_field);
      })) {
        return true;
      }

      return false;
    }
  }, {
    key: "findCategoryParentsFor",
    value: function findCategoryParentsFor(categoryData) {
      var parentsCollection = [];
      var categoryParentData = this.findCategoryByContainingValueFor('subcategories', categoryData['id']);
      parentsCollection.push(categoryData['id']);

      if (categoryParentData) {
        parentsCollection = categoryParentData['parent'] ? [].concat(_toConsumableArray(parentsCollection), _toConsumableArray(this.findCategoryParentsFor(categoryParentData))) : [].concat(_toConsumableArray(parentsCollection), [categoryParentData['id']]);
      }

      return parentsCollection;
    }
  }, {
    key: "retrieveCheckboxParents",
    value: function retrieveCheckboxParents(field, value) {
      var collection = [];
      var fieldCategoryData = this.findCategoryByContainingValueFor('fields', field);

      if (value && this.isCategoryFullyCompleted(field, fieldCategoryData['fields'])) {
        collection.push(fieldCategoryData['id']);
      } else if (!value) {
        collection = this.findCategoryParentsFor(fieldCategoryData);
      }

      return collection;
    }
  }, {
    key: "retrieveNestedCheckboxesByCategoryName",
    value: function retrieveNestedCheckboxesByCategoryName(selectedCategoryId) {
      var _this2 = this;

      var collection = [];
      var categoryData = this.findCategoryById(selectedCategoryId);

      if (categoryData && categoryData['fields'].length) {
        collection = [].concat(_toConsumableArray(collection), _toConsumableArray(categoryData['fields']));
      } else if (categoryData && categoryData['subcategories'].length) {
        categoryData['subcategories'].forEach(function (element) {
          collection = [].concat(_toConsumableArray(collection), _toConsumableArray(_this2.retrieveNestedCheckboxesByCategoryName(element)));
        });
      }

      return collection;
    }
  }, {
    key: "retrieveNestedCategoriesByCategoryName",
    value: function retrieveNestedCategoriesByCategoryName(selectedCategoryId) {
      var _this3 = this;

      var result = [];
      var categoryData = this.findCategoryById(selectedCategoryId);

      if (categoryData && categoryData['subcategories'].length) {
        result = [].concat(_toConsumableArray(result), _toConsumableArray(categoryData['subcategories']));
        categoryData['subcategories'].forEach(function (element) {
          result = [].concat(_toConsumableArray(result), _toConsumableArray(_this3.retrieveNestedCategoriesByCategoryName(element)));
        });
      }

      return result;
    }
  }]);

  return CheckboxesByCategory;
}();

export default CheckboxesByCategory;